import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import {
  SimpleGrid,
  Container,
  Heading,
  Button,
  VStack,
  Stack,
  Text,
} from "@chakra-ui/react"
import { HeroAnimation } from "./animations/hero"
import { handleMenuLinkClick } from "../../../handlers"
import { Icon } from "../../"

export function Hero() {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  const { title, description } = site.siteMetadata

  return (
    <section>
      <Container>
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          spacing={{ base: 0, lg: 8 }}
          alignItems="center"
        >
          <VStack align={{ base: "center", lg: "start" }} spacing={8}>
            <Heading
              size="6xl"
              fontWeight="semibold"
              textAlign={{ base: "center", lg: "left" }}
            >
              {title}
            </Heading>
            <Heading size="xl" textAlign={{ base: "center", lg: "left" }}>
              {description}
            </Heading>

            <Stack
              direction={{
                base: "column",
                md: "row",
                lg: "column",
                xl: "row",
              }}
              spacing={4}
            >
              <Button
                as={Link}
                to={"/#contact"}
                onClick={event => handleMenuLinkClick("/#contact", event)}
                variant="primary"
                size="lg"
              >
                <Text as="span" lineHeight={1} fontWeight="bold">
                  Get in touch
                </Text>
                <Icon name="email" boxSize={6} ml={3} />
              </Button>
              <Button
                as={Link}
                to={"/#packages"}
                onClick={event => handleMenuLinkClick("/#packages", event)}
                variant="ghost"
                colorScheme="primary"
                size="lg"
              >
                <Text as="span" lineHeight={1} fontWeight="bold">
                  Our Packages
                </Text>
                <Icon name="arrowRight" boxSize={6} ml={3} />
              </Button>
            </Stack>
          </VStack>

          <HeroAnimation
            maxH={{ base: "500px", lg: "600px" }}
            mt={{ base: 20, lg: 0 }}
          />
        </SimpleGrid>
      </Container>
    </section>
  )
}
